export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=70990945e0482a3e63b1a0f3c5cc1128cf4c3518d5&name=getStoresServerAction!'